var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.consents.length)?_c('check-consent',{attrs:{"value":_vm.value}}):_c('chase-consent',{attrs:{"value":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }